<template>
  <div>
    <vmodal
      name="addSupplierModal"
      height="auto"
      width="920"
      :adaptive="true"
      :scrollable="true"
      class="addSupplierModal"
      @opened="onSupplierModalOpened"
    >
      <div class="supplier-modal card">
        <div class="card-content supplier-modal__content">
          <div class="supplier-modal__header">
            <h5 class="supplier-modal__title">
              {{ editMode ? 'Editează furnizor' : $t('gestiune.addSupplier') }}
            </h5>
          </div>

          <div class="supplier-modal__body">
            <div class="row supplier-modal__toolbar">
              <div class="col-md-6">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.locatie') }}</label>
                  <select
                    class="form-control supplier-modal__select"
                    v-model="selectedLocationId"
                    :key="'supplier-location-' + selectedLocationId"
                    :disabled="editMode"
                  >
                    <option value="" disabled>Selectează locația</option>
                    <optgroup
                      v-for="group in groupedLocations"
                      :key="group.vat"
                      :label="String(group.vat)"
                    >
                      <option
                        v-for="loc in group.locations"
                        :key="String(loc.true_id)"
                        :value="String(loc.true_id)"
                      >
                        {{ loc.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.searchByCUI') }}</label>
                  <form @submit.prevent="searchSupplier" class="supplier-modal__search">
                    <input
                      type="text"
                      v-model="searchCUI"
                      class="form-control input-sm"
                      :placeholder="$t('gestiune.searchByCUI')"
                    />
                    <button type="submit" class="btn btn-primary btn-sm supplier-modal__search-btn">
                      {{ $t('general.search') }}
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <div class="row supplier-modal__form-grid">
              <div class="col-md-4">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.companyName') }}*</label>
                  <input type="text" v-model="supplier.companyName" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.abbreviation') }}*</label>
                  <input type="text" v-model="supplier.abbreviation" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.CUI') }}*</label>
                  <input type="text" v-model="supplier.CUI" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.registrationNumber') }}*</label>
                  <input type="text" v-model="supplier.registrationNumber" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.email') }}*</label>
                  <input type="text" v-model="supplier.email" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.dueDays') }}*</label>
                  <input type="number" v-model="supplier.dueDays" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.address') }}*</label>
                  <input type="text" v-model="supplier.address" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-5">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.bank') }}*</label>
                  <input type="text" v-model="supplier.bank" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-7">
                <div class="form-group supplier-modal__field">
                  <label>{{ $t('gestiune.IBAN') }}*</label>
                  <input type="text" v-model="supplier.IBAN" class="form-control input-sm" />
                </div>
              </div>
            </div>
          </div>

          <div class="supplier-modal__footer">
            <a class="btn btn-danger btn-icon delete" @click="closeAddSupplierModal()">
              {{ $t('general.cancel2') }}
            </a>
            <button class="btn btn-icon btn-success save" @click="saveSupplier()">
              {{ $t('general.save') }}
            </button>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>

<script>
  import swal from 'sweetalert2'

  export default {
    data () {
      return {
        selectedVatNumber: null,
        selectedLocationId: '',
        selectedLocation: null,
        vatNumber: null,
        supplier: {
          companyName: '',
          abbreviation: '',
          CUI: '',
          registrationNumber: '',
          email: '',
          address: '',
          bank: '',
          IBAN: '',
          dueDays: null
        },
        searchCUI: '',
        pendingSupplierRow: null
      }
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      },
      getSuppliers: {
        type: Function,
        required: false
      },
      supplierData: {
        type: Object,
        default: () => ({})
      },
      editMode: {
        type: Boolean,
        default: false
      },
      filterVatNumber: {
        type: [String, Number],
        default: null
      }
    },
    watch: {
      selectedLocationId (id) {
        this.selectedLocation = this.findLocationById(id)
      },
      supplierData: {
        deep: true,
        immediate: true,
        handler (val) {
          if (!val || !Object.keys(val).length) return

          const isEmptyForm = !val.id && !val.companyName && !val.CUI && !val.cui && !val.externalLocationId

          this.supplier = this.mapSupplierRowToForm(val)
          this.searchCUI = ''

          if (!this.editMode && isEmptyForm) {
            this.pendingSupplierRow = null
            this.selectedLocationId = ''
            this.selectedLocation = null
            return
          }

          this.pendingSupplierRow = val
          this.$modal.show('addSupplierModal')
          this.$nextTick(() => {
            this.applySupplierLocation(val)
          })
        }
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')
    },
    methods: {
      idsMatch (a, b) {
        if (a == null || b == null || a === '') return false
        return String(a) === String(b)
      },
      vatKey (vat) {
        if (vat == null) return ''
        return String(vat).trim()
      },
      getAllLocations () {
        return (this.groupedLocations || []).flatMap(group => group.locations || [])
      },
      findLocationById (id) {
        if (id == null || id === '') return null

        return this.getAllLocations().find(loc =>
          this.idsMatch(loc.true_id, id) || this.idsMatch(loc.id, id)
        ) || null
      },
      findLocationByVatNumber (vatNumber) {
        const vat = this.vatKey(vatNumber)
        if (!vat) return null

        const group = (this.groupedLocations || []).find(item => this.vatKey(item.vat) === vat)
        if (group && group.locations && group.locations.length) {
          return group.locations[0]
        }

        return this.getAllLocations().find(loc => this.vatKey(loc.inv_fiscal_code) === vat) || null
      },
      applySupplierLocation (row = {}) {
        const found = this.findLocationById(row.externalLocationId) ||
          this.findLocationByVatNumber(this.filterVatNumber) ||
          this.findLocationByVatNumber(row.vatNumber)

        if (found) {
          this.selectedLocationId = String(found.true_id)
          this.selectedLocation = found
          return
        }

        this.selectedLocationId = ''
        this.selectedLocation = null
      },
      onSupplierModalOpened () {
        if (!this.pendingSupplierRow) return

        this.$nextTick(() => {
          this.applySupplierLocation(this.pendingSupplierRow)
          this.pendingSupplierRow = null
        })
      },
      mapSupplierRowToForm (row = {}) {
        return {
          companyName: row.companyName || row.distributorName || row.name || '',
          abbreviation: row.abbreviation || '',
          CUI: row.CUI || row.cui || row.supplierVatNumber || '',
          email: row.email || '',
          registrationNumber: row.registrationNumber || '',
          address: row.address || '',
          bank: row.bank || '',
          IBAN: row.IBAN || row.iban || '',
          dueDays: row.dueDays != null ? row.dueDays : null,
          id: row.id || row._id || null,
          _rev: row._rev || null,
          externalLocationId: row.externalLocationId || null,
          vatNumber: row.vatNumber || null
        }
      },
      openAddSupplierModal () {
        this.editMode = false
        this.selectedLocationId = ''
        this.searchCUI = ''
        this.supplier = {
          companyName: '',
          abbreviation: '',
          CUI: '',
          email: '',
          registrationNumber: '',
          address: '',
          bank: '',
          IBAN: '',
          dueDays: null,
          id: null,
          _rev: null
        }
        this.$modal.show('addSupplierModal')
      },
      closeAddSupplierModal () {
        this.editMode = false
        this.$modal.hide('addSupplierModal')
      },
      async searchSupplier () {
        try {
          if (!this.searchCUI) {
            swal({
              title: 'Error',
              text: 'Please enter a CUI to search.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
            return
          }

          const company = await this.fetchAnafCompanyByCui(this.searchCUI)
          this.supplier = this.mapSupplierRowToForm({
            ...this.supplier,
            companyName: company.name,
            CUI: company.cui || this.supplier.CUI,
            registrationNumber: company.registrationNumber,
            address: company.address,
            IBAN: company.iban
          })
        } catch (error) {
          console.error('Error fetching supplier details:', error)
          swal({
            title: 'Error',
            text: error.message || 'Failed to retrieve supplier details.',
            type: 'error',
            timer: 2500,
            showConfirmButton: false
          })
        }
      },
      async saveSupplier () {
        try {
          if (!this.selectedLocationId || !this.supplier.CUI || !this.supplier.companyName || !this.supplier.address) {
            swal({
              title: 'Error',
              text: 'Toate câmpurile marcate cu * sunt obligatorii.',
              icon: 'error',
              timer: 1500,
              buttons: false
            })
            return
          }

          const selectedLocation = this.findLocationById(this.selectedLocationId)

          if (!selectedLocation) {
            swal({
              title: 'Error',
              text: 'Locația selectată este invalidă.',
              icon: 'error',
              timer: 1500,
              buttons: false
            })
            return
          }

          const supplierData = {
            externalCompanyId: this.companyID,
            externalLocationId: selectedLocation.true_id,
            vatNumber: selectedLocation.inv_fiscal_code,
            supplierVatNumber: this.supplier.CUI,
            name: this.supplier.companyName,
            abbreviation: this.supplier.abbreviation || '',
            registrationNumber: this.supplier.registrationNumber || '',
            email: this.supplier.email || '',
            address: this.supplier.address,
            bank: this.supplier.bank || '',
            iban: this.supplier.IBAN || '',
            dueDays: this.supplier.dueDays != null ? Number(this.supplier.dueDays) : 0
          }

          if (this.editMode && this.supplier.id) {
            supplierData.id = this.supplier.id
            if (this.supplier._rev) {
              supplierData._rev = this.supplier._rev
            }
          }

          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/supplier`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(supplierData)
          })

          if (!response.ok) {
            throw new Error('Eroare la salvarea furnizorului')
          }

          const responseData = await response.json()
          console.log('Furnizor salvat:', responseData)

          swal({
            title: 'Succes',
            text: 'Furnizorul a fost salvat cu succes.',
            icon: 'success',
            timer: 1500,
            buttons: false
          })

          this.$emit('getSuppliers')

          this.$modal.hide('addSupplierModal')
        } catch (error) {
          console.error('Eroare la salvarea furnizorului:', error)
          swal({
            title: 'Error',
            text: error.message,
            icon: 'error',
            timer: 1500,
            buttons: false
          })
        }
      }
    }
  }
</script>

<style scoped>
.supplier-modal__content {
  padding: 0 !important;
}

.supplier-modal__header {
  padding: 14px 18px 10px;
  border-bottom: 1px solid #ececf1;
}

.supplier-modal__title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #1f2937;
}

.supplier-modal__body {
  padding: 12px 18px 4px;
  max-height: min(58vh, 520px);
  overflow-y: auto;
}

.supplier-modal__toolbar {
  margin-bottom: 4px;
}

.supplier-modal__form-grid {
  margin-top: 0;
}

.supplier-modal__field {
  margin-bottom: 10px;
}

.supplier-modal__field label {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
}

.supplier-modal__field .form-control {
  min-height: 38px;
  line-height: 1.4;
  padding: 8px 12px;
  font-size: 14px;
}

.supplier-modal__select {
  height: 40px;
  line-height: normal;
  padding: 8px 12px;
  appearance: auto;
  -webkit-appearance: menulist;
}

.supplier-modal__select:disabled {
  background-color: #f3f4f6;
  color: #6b7280;
  cursor: not-allowed;
  opacity: 1;
}

.supplier-modal__search {
  display: flex;
  gap: 8px;
}

.supplier-modal__search-btn {
  flex-shrink: 0;
  padding: 6px 16px;
}

.supplier-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 18px 16px;
  border-top: 1px solid #ececf1;
  background: #fafafa;
}

.supplier-modal__footer .btn-success {
  background-color: #7ac29a !important;
  border-color: #7ac29a !important;
  color: #fff !important;
  opacity: 1;
}

.supplier-modal__footer .btn-danger {
  background-color: #f8d7da !important;
  border-color: #f5c2c7 !important;
  color: #b02a37 !important;
  opacity: 1;
}

.supplier-modal.card {
  margin: 0;
  border: none;
  box-shadow: none;
}
</style>

<style>
.addSupplierModal .v--modal {
  border-radius: 12px;
  overflow: hidden;
}

.addSupplierModal .v--modal-box {
  overflow: hidden;
  max-height: 92vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Suppliers/ManagementSuppliersAdd.vue